import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import * as actions from './actions';
import CommentEditor from './commentEditor';
import { useActions } from 'hooks/useActions';
import { Spinner } from 'components/Spinner/Spinner';
import { CommentContainerSection } from './styles';
import CommentDisplay from './commentDisplay';

export default function CommunityComments({ testId, contestId, isDarkMode }) {
  const { getComments } = useActions(actions);
  const {
    error,
    createCommentError,
    rootCommentIds: { [contestId || testId]: commentIds },
    commentsLoading,
  } = useSelector((state) => state.commentsReducer);
  const { isCommunityUser } = useSelector((state) => state.auth);

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  useEffect(() => {
    if (createCommentError) {
      toast.error(createCommentError);
    }
  }, [createCommentError]);

  useEffect(() => {
    if (!commentIds?.length && (testId || contestId)) {
      getComments(testId, contestId);
    }
  }, [testId, contestId, commentIds?.length, getComments]);

  return (
    <CommentContainerSection isDarkMode={isDarkMode}>
      {!isCommunityUser && <p>Join the community to comment</p>}
      {isCommunityUser && <CommentEditor testId={testId} contestId={contestId} />}
      {commentsLoading && <Spinner />}
      {commentIds &&
        commentIds.map((commentId) => <CommentDisplay key={commentId} commentId={commentId} commentLevel={0} />)}
      {isCommunityUser && !commentIds?.length && !commentsLoading && (
        <p>Be the first to contribute to the discussion</p>
      )}
    </CommentContainerSection>
  );
}
